import config from '../config';

const appConfig = config();
const { v2 } = appConfig.apiVersion;
const { apiPrefix } = appConfig;
const ticketsUrl = `${apiPrefix}${v2}/tickets`;

export default class RegistrationTicketService {
  constructor(client) {
    this.client = client;
  }

  async createCollaborator(payload) {
    const response = await this.client.post(
      `${ticketsUrl}/registration`,
      payload
    );
    return response.data;
  }

  async createCompany(payload) {
    const response = await this.client.post(
      `${ticketsUrl}/registration-company`,
      payload
    );
    return response.data;
  }
}
